module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "landing-header",
    class: [_vm.isHidden ? 'hidden' : '']
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('side-menu-toggler')], 1), _vm._v(" "), _c('div', {
    staticClass: "header-body"
  }, [_c('transition', {
    attrs: {
      "name": "stock-info"
    }
  }, [(_vm.isHome) ? _c('stock-info', {
    staticClass: "d-none d-xl-block"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "header-body-container"
  }, [_c('router-link', {
    staticClass: "ruyi-logo align-self-center",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".home")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/logos/ruyi.svg")
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "go-back-button"
    }
  }, [(!_vm.isHome) ? _c('button', {
    staticClass: "go-back-button d-none d-xl-block",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/arrow-left.svg")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "links d-none d-md-flex justify-content-end"
  }, [_c('site-nav'), _vm._v(" "), _c('language-switcher')], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d344d418","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LandingHeader.vue
// module id = 637
// module chunks = 1